import * as React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Label, Loader } from "semantic-ui-react";

import { OrgStructureEditModel } from "@teamprevent/common/orgStructure/models";

import { useCustomerDetailsModel } from "../../customer/hooks";

export const Edit = () => {
    const { customer, isLoaded } = useCustomerDetailsModel();
    const { register, formState: { errors }, watch, setValue, control } = useFormContext<OrgStructureEditModel>();
    const billing = watch("billing");

    React.useEffect(() => {
        if (isLoaded && !billing) {
            setValue("financeCustomerName", "");
            setValue("accountCode", "");
            setValue("contractCode", "");
            setValue("allowanceStartDate", undefined);
            setValue("allowanceEndDate", undefined);
            setValue("purchaseOrderNumber", undefined);
        }
    }, [billing, isLoaded, setValue]);

    if (!isLoaded)
    {
        return <Loader active />;
    }

    return (
        <>
            <Form.Field>
                <label>Name *</label>
                <input required {...register("name")} />
                {errors.name?.message
                    && (<Label pointing="above" color="red">{errors.name.message}</Label>)
                }
            </Form.Field>
            {customer.orgLevel1Billing &&
                <Form.Field>
                    <Controller
                        name="billing"
                        control={control}
                        render={({ field: { value, onChange } }) => (<Form.Checkbox
                            label="Billing"
                            name="billing"
                            onChange={(e, data) => onChange(data.checked)}
                            checked={value}
                        />)}
                    />
                    {errors.billing?.message
                        && (<Label pointing="above" color="red">{errors.billing.message}</Label>)
                    }
                </Form.Field>
            }
            {
                billing && customer.orgLevel1Billing &&
                <>
                    <h3>FINANCE INFORMATION</h3>
                    <Form.Field>
                        <label>Finance Customer Name</label>
                        <input {...register("financeCustomerName")} />
                        {errors.financeCustomerName?.message
                            && (<Label pointing="above" color="red">{errors.financeCustomerName.message}</Label>)
                        }
                    </Form.Field>
                    <Form.Field>
                        <label>Finance Customer Reference</label>
                        <input {...register("accountCode")} />
                        {errors.accountCode?.message
                            && (<Label pointing="above" color="red">{errors.accountCode.message}</Label>)
                        }
                    </Form.Field>
                    <Form.Field>
                        <label>Finance Cost Centre</label>
                        <input {...register("contractCode")} />
                        {errors.contractCode?.message
                            && (<Label pointing="above" color="red">{errors.contractCode.message}</Label>)
                        }
                    </Form.Field>
                    <Form.Field>
                        <label>Allowance Start Date</label>
                        <input
                            type="date"
                            {...register("allowanceStartDate")}
                        />
                        {errors.allowanceStartDate?.message
                            && (<Label pointing="above" color="red">{errors.allowanceStartDate.message}</Label>)
                        }
                    </Form.Field>
                    <Form.Field>
                        <label>Allowance End Date</label>
                        <input
                            type="date"
                            {...register("allowanceEndDate")}
                        />
                        {errors.allowanceEndDate?.message
                            && (<Label pointing="above" color="red">{errors.allowanceEndDate.message}</Label>)
                        }
                    </Form.Field>
                    <Form.Field>
                        <label>Org Level 1 Purchase Order Number</label>
                        <input {...register("purchaseOrderNumber")} />
                        {errors.purchaseOrderNumber?.message
                            && (<Label pointing="above" color="red">{errors.purchaseOrderNumber.message}</Label>)
                        }
                    </Form.Field>
                </>
            }
            <Form.Field>
                <label>Customer</label>
                <span>{customer.name}</span>
            </Form.Field>
        </>
    );
};
